module.exports = __webpack_public_path__ + "static/media/red-dot.c19489b1.svg";